
import React, { useState } from 'react';
import { Modal, Button, Table, Badge } from 'react-bootstrap';
import AddProductionPlanModal from './AddProductionPlanModal';

const orders = [
  {
    id: 'ORD-002',
    product: 'Component D',
    customer: 'MechSolutions Ltd',
    quantity: 1200,
    machine: 'CNC Mill 1, Assembly 1',
    start: '2025-04-10',
    end: '2025-05-20',
    status: 'Sufficient',
  },
  {
    id: 'ORD-003',
    product: 'Bracket B',
    customer: 'ElectroParts Co',
    quantity: 800,
    machine: 'CNC Mill 2',
    start: '2025-04-25',
    end: '2025-05-28',
    status: 'Sufficient',
  },
  {
    id: 'ORD-005',
    product: 'Housing A',
    customer: 'InnovateX',
    quantity: 650,
    machine: 'CNC Mill 1',
    start: '2025-03-25',
    end: '2025-05-12',
    status: 'Partial Shortage',
  },
  {
    id: 'ORD-006',
    product: 'Assembly E',
    customer: 'PrimeMech Inc',
    quantity: 120,
    machine: 'Assembly 1',
    start: '2025-05-05',
    end: '2025-05-30',
    status: 'On Order',
  },
];

const getBadgeVariant = (status) => {
  switch (status) {
    case 'Sufficient':
      return 'dark';
    case 'Partial Shortage':
      return 'danger';
    case 'On Order':
      return 'secondary';
    default:
      return 'light';
  }
};

export default function NewPOsModal({ show, handleClose }) {
  const [addProductionPlan, setAddProductionPlan] = useState(false);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        centered
        className="font_family"
      >
        <Modal.Body className="p-5">
          <strong className="fs-4">New POs</strong>
          <Table striped responsive className="mt-3 align-middle">
            <thead>
              <tr>
                <th className="text-nowrap">Order ID</th>
                <th className="text-nowrap">Product</th>
                <th className="text-nowrap">Customer</th>
                <th className="text-nowrap">Quantity</th>
                <th className="text-nowrap">Machine Assignment</th>
                <th className="text-nowrap">Timeline</th>
                <th className="text-nowrap">Material Status</th>
                <th className="text-nowrap">Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id}>
                  <td className="text-nowrap">{order.id}</td>
                  <td className="text-nowrap">{order.product}</td>
                  <td className="text-nowrap">{order.customer}</td>
                  <td className="text-nowrap">{order.quantity}</td>
                  <td className="text-nowrap">{order.machine}</td>
                  <td className="text-nowrap">
                    Start: {order.start} | End: {order.end}
                  </td>
                  <td className="text-nowrap">
                    <Badge bg={getBadgeVariant(order.status)}>
                      {order.status}
                    </Badge>
                  </td>
                  <td className="text-nowrap">
                    <Button
                      variant="outline-dark"
                      size="sm"
                      disabled={order.status === 'Partial Shortage'}
                      onClick={() => setAddProductionPlan(true)}
                    >
                      Add to Plan
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>

      {/* AddProductionPlanModal - nested modal */}
      <AddProductionPlanModal
        show={addProductionPlan}
        handleClose={() => setAddProductionPlan(false)}
      />
    </>
  );
}
